export default __webpack_public_path__ + "static/6-airbnb-or-hotels-91ee2c1e005a7911c3aeea945c6a663f.jpg";